import { render, staticRenderFns } from "./WorkBaseRestrictedTextField.vue?vue&type=template&id=ba0d1d7a&scoped=true"
import script from "./WorkBaseRestrictedTextField.vue?vue&type=script&lang=js"
export * from "./WorkBaseRestrictedTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseRestrictedTextField.vue?vue&type=style&index=0&id=ba0d1d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0d1d7a",
  null
  
)

export default component.exports